<template>
  <div style="padding-top: 40px; padding-left: 0px;">
    <!-- <span>{{ Time }}</span> -->
    <b style="font-size: 500px; line-height: 500px;"></b>
    <div id="QRA">
      <h2 style="color: var(--dark);">Scan QR CODE Member ID</h2>
      <img src="../../../static/scan.gif" width="400" />
      <hr />
      <button type="button" class="btn btn-danger btn-lg" style="font-size: 40px;" @click="Cancel">
        <b v-if="$store.state.lang == 0">Cancel</b>
        <b v-if="$store.state.lang == 1">ยกเลิก</b>
        <b v-if="$store.state.lang == 2">取消</b>
      </button>
    </div>
  </div>
</template>

<script>
import { mapState, mapMutations } from "vuex"
import $ from "jquery"
import Loading from "vue-loading-overlay"
import "vue-loading-overlay/dist/vue-loading.css"
import Swal from "sweetalert2"
import api from "../../service/services"
export default {
  data() {
    return {
      Time: 100,
      authen_qrcode: "",
      qr_base64: "",
      remain_sec: "",
      step: ""
    }
  },
  computed: {
    ...mapState([
      "lang",
      "UUID",
      "accessToken",
      "Mode",
      "Type",
      "AmountPayment",
      "AuthenType",
      "isconnect_emitterpay",
      "StatusQrcode",
      "customerBalance",
      "stepauthmember",
      "phone_member"
    ]),
    ...mapMutations(["onMessageWs"])
  },
  created () {
    this.$store.state.member_auth_fact = true
    this.$barcodeScanner.init(this.onBarcodeScanned)
  },
  methods: {
    Cancel() {
      $("#Modal").modal("hide")
    },
    validateID(CodeID) {
      const header = {
        headers: {
          //"x-access-token": "4fa68bf1a9e042e6bef54de6542c2efa"
          "x-access-token": this.$store.state.accessToken
        }
      }

      const body = {
        // _compgrp: "commons",
        // _comp: "api",
        // _action: "validate",
        // vending_id: this.$store.state.UUID,
        code: CodeID
      }
      api.checkValidate(
        body,
        header,
        result => {
          this.$store.state.StatusQrcode = ''
          $("#Modal").modal("hide")
          console.log(result)
          if (result.response == "available") {
            this.$store.state.memberType = 1
            this.authen_qrcode = ""
            this.$store.state.StatusQrcode = ""
            this.$store.state.phone_member = ""
            this.$router.push("/shopping")
          } else {
            let text = ""
            let title = ""
            let text2 = ""
            let title2 = ""
            let ButtonText =""
            switch (this.lang) {
              case 0:
                text = "Member code not found Please contact staff"
                title = "Notification"
                ButtonText = "Close"
                break
              case 2:
                text = "找不到会员代码 请联系工作人员"
                title = "來自系統的通知"
                ButtonText = ""
                break
              default:
                text = "ไม่พบรหัสสมาชิก กรุณาติดต่อเจ้าหน้าที่"
                title = "แจ้งเตือนจากระบบ"
                ButtonText = "ปิด"
                break
            }
            Swal.fire({
                text: text,
                title: title,
                type: 'error',
                timer: 10000,
                // type: "warning",
                // confirmButtonColor: "#3085d6",
                // cancelButtonColor: "#d33",
                confirmButtonText: ButtonText
              })
              // .then(result => {
              //   if (result.value) {
              //     this.$store.state.memberType = 0
              //     this.authen_qrcode = ""
              //     this.$store.state.StatusQrcode = ""
              //     this.$router.push("/shopping")
              //   }
              // })
          }
        },
        error => {
          this.$store.state.StatusQrcode = ''
          alert(JSON.stringify(error))
          this.$store.state.isLoading = false
        }
      );
    },
    CheckMemberC9(CodeID) {
      //test
      const header = {
        headers: {
          // "X-Access-Token": "12c1840ca3664dd799db80ce5f6a5b21"
          // "X-Access-Token": "5725a8c515594fcc81561169ba753087"
           "x-access-token": this.$store.state.accessToken
        }
      }
      //product
      const body = {
        code: CodeID
      }
      console.log(body)
      api.checkValidate(
        body,
        header,
        result => {
          this.$store.state.StatusQrcode = ''
          $("#Modal").modal("hide")
          console.log(result)
          if (result.response == "available") {
            this.$store.state.memberType = 1
            this.authen_qrcode = ""
            this.$store.state.StatusQrcode = ""
            this.$store.state.memberProfile = result.data
            console.log("memberProfile:",this.$store.state.memberProfile)
            this.$store.state.flag_member = 1,
            this.$router.push("/shopping")
          } else {
            let text = ""
            let title = ""
            let text2 = ""
            let title2 = ""
            let ButtonText =""
            switch (this.lang) {
              case 0:
                text = "Member code not found Please contact staff"
                title = "Notification"
                ButtonText = "Close"
                break
              case 2:
                text = "找不到会员代码 请联系工作人员"
                title = "來自系統的通知"
                ButtonText = ""
                break
              default:
                text = "ไม่พบรหัสสมาชิก กรุณาติดต่อเจ้าหน้าที่"
                title = "แจ้งเตือนจากระบบ"
                ButtonText = "ปิด"
                break
            }
            Swal.fire({
                text: text,
                title: title,
                type: 'error',
                timer: 10000,
                confirmButtonText: ButtonText
              })
          }
        },
        error => {
          this.$store.state.StatusQrcode = ''
          alert(JSON.stringify(error))
          this.$store.state.isLoading = false
        }
      )
    },
    onBarcodeScanned (barcode) {
      console.log(barcode)
      this.authMember(barcode)
    },
    authMember (barcode) {
      console.log("authMember")
      if (barcode) {
        if (barcode == "memberpass1111") {
          barcode = ''
          $("#Modal").modal("hide")
          this.$store.state.memberType = 1
          this.authen_qrcode = ""
          this.$router.push("/shopping")
        console.log(barcode)
        } else {
        console.log(barcode)
        this.CheckMemberC9(barcode)
        }
      }
    },
    websocket_onmessage() {
      this.$socket.onmessage = skResult => {
        const data = JSON.parse(skResult.data)
        if ((data.command = "qr")) {
          if (this.$store.state.member_auth_fact == true) {
            this.authMember(data.data)
          }
        }
        this.$store.commit("onMessageWs", JSON.parse(skResult.data))
      }
    }
  },
  mounted() {
    // this.$store.state.StatusQrcode = "+66613351889"
    // this.websocket_onmessage()
    // setTimeout(() => {
    //   this.validateID("+666133456451889")
    // }, 3000)
    this.websocket_onmessage()
    // this.$store.state.stepauthmember = setInterval(() => {
    //   console.log("log")
    //   if (this.$store.state.StatusQrcode) {
    //     console.log("log")
    //     if (this.$store.state.StatusQrcode == "memberpass1111") {
    //       this.$store.state.StatusQrcode = ''
    //       $("#Modal").modal("hide")
    //       this.$store.state.memberType = 1
    //       this.authen_qrcode = ""
    //       this.$router.push("/shopping")
    //       clearInterval(this.$store.state.stepauthmember)
    //     console.log(this.$store.state.StatusQrcode)
    //     } else {
    //     console.log(this.$store.state.StatusQrcode)
    //     // this.validateID(this.$store.state.StatusQrcode)
    //     this.CheckMemberC9(this.$store.state.StatusQrcode)
    //     clearInterval(this.$store.state.stepauthmember)
    //     }
    //   }
    // }, 1000);
  },
  beforeDestroy () {
    this.$store.state.member_auth_fact = false
    this.$barcodeScanner.destroy()
  }
};
</script>



// WEBPACK FOOTER //
// src/components/modal/memberauthen.vue